import type React from "react";

interface SetupStepProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  mask?: (value: string) => string;
  validate?: (value: string) => boolean;
  helperText?: string;
  errorMessage?: string;
}

export const SetupStep: React.FC<SetupStepProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  mask,
  validate,
  helperText,
  errorMessage,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    if (mask) {
      newValue = mask(newValue);
    }
    onChange(newValue);
  };

  const isValid = validate ? validate(value) : true;

  return (
    <div className="w-full max-w-md">
      <p className="mb-2 text-sm font-medium text-[#050505]/70">{label}</p>
      <label htmlFor={label.toLowerCase().replace(" ", "-")} className="sr-only">
        {label}
      </label>
      <input
        id={label.toLowerCase().replace(" ", "-")}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        type={type}
        className={`w-full text-3xl font-bold bg-transparent border-b-2 border-[#EE7B11] focus:outline-none focus:border-[#050505] transition-all duration-300 pb-2 placeholder-[#050505]/50 ${
          !isValid ? "border-red-500" : ""
        }`}
      />
      {helperText && <p className="mt-2 text-xs text-[#050505]/60">{helperText}</p>}
      {!isValid && (
        <p className="mt-2 text-sm text-red-500">
          {errorMessage || "Por favor, insira um valor valido."}
        </p>
      )}
    </div>
  );
};
